import { ProductMenuModifierDto } from "@up/data";

export interface PosOpenPriceDialogResult {
  hasNewPrice: boolean;
  productMenuModifier?: ProductMenuModifierDto;
}
